export default __webpack_public_path__ + "static/media/Lora.3baea9fc.png";